import React from 'react';
import AccessoryList from 'webshop/js/accessory-list';
import TireList from 'webshop/js/tire-list';
import WheelList from 'webshop/js/wheel-list';
import Pagination from 'webshop/js/pagination';
import ShoppingCartManager from 'webshop/js/shopping-cart-manager';


var PagedProducts = React.createClass({
    propTypes: {
        type: React.PropTypes.oneOf(['wheel', 'tire', 'accessory']),
        car: React.PropTypes.shape({
            brand: React.PropTypes.string,
            model: React.PropTypes.string,
            details: React.PropTypes.string
        }),
        page: React.PropTypes.oneOf(['auton-renkaat', 'auton-vanteet', 'renkaat', 'vanteet', 'vannehaku', 'rengashaku', 'tarvikkeet', 'momo']),
        productType: React.PropTypes.oneOf(['', 'vanteet', 'kesarenkaat', 'kitkarenkaat', 'nastarenkaat', 'kilparenkaat', 'motorsport', 'tarvikkeet', 'tilausvanteet'])
    },
    componentDidMount: function () {
        ShoppingCartManager.ShoppingCartManager.on('change', this.updateCartData);
    },
    componentDidUpdate: function(prevProps, prevState) {
        if(this.state.products && prevState.products !== this.state.products) {
            const tireTypes = {
                'summer': 'Kesärenkaat',
                'friction': 'Kitkarenkaat',
                'studded': 'Nastarenkaat',
                'truck': 'KA',
                'work': 'TK',
                'race': 'Kilparenkaat',
                'other': 'Muut renkaat',
            };

            let impressions = this.state.products.map(
                (product, i) => product.product_type === 'wheel' ? {
                    name: product.brand + ' ' + product.model,
                    id: product.id,
                    price: product.unit_price,
                    brand: product.brand,
                    category:
                      `${product.wheel_type == 'alloy' ? 'Alumiinivanteet' : 'Peltivanteet'}${product.used ? ' käytetyt' : ''}`,
                    list: this.props.productType,
                    position: i,
                } : (product.type === 'tire' ? {
                    name: product.brand + ' ' + product.model + ' ' + product.title_extra,
                    id: product.id,
                    price: product.unit_price,
                    brand: product.brand,
                    category: `${tireTypes[product.tire_type]}${product.used ? ' käytetyt' : ''}`,
                    list: this.props.productType,
                    position: i,
                } : {
                    name: product.brand + ' ' + product.model + ' ' + product.title_extra,
                    id: product.id,
                    price: product.unit_price,
                    brand: product.brand,
                    category: '',
                    list: this.props.page,
                    position: i,
                })
            );
            dataLayer.push({
                "event" : "ecomImpression",
                'ecommerce': {
                    'currencyCode': 'EUR',                       // Local currency is optional.
                    'impressions': impressions
                }
            });
        }
    },
    updateCartData: function() {
        var data = ShoppingCartManager.ShoppingCartManager.getAll();
        if (data) {
            this.setState({cartData: data});
        }
    },
    getInitialState: function () {
        return {
            products: this.props.products,
            pagination: this.props.pagination,
            waiting: false,
            cartData: this.props.cartData,
            car: this.props.car,
            page: this.props.page,
            productType: this.props.productType,
        };
    },
    render: function() {
        var productList,
            pagination = this.state.pagination;

        if (!this.state.waiting && (!this.state.products || !this.state.products.length)) {
            return (
                <div className="no-results">
                    <p>Haulla ei löytynyt tuotteita.</p>
                </div>
                );
        }
        if (this.props.type == 'wheel') {
            productList = <WheelList products={this.state.products}
                                     cartData={this.state.cartData}
                                     car={this.state.car}/>;
        } else if (this.props.type == 'tire') {
            productList = <TireList products={this.state.products}
                                    cartData={this.state.cartData}/>;
        } else {
            productList = <AccessoryList products={this.state.products}
                                         cartData={this.state.cartData}/>;
        }

        var paginationEl = null;
        if (pagination && 1 < pagination.pages) {
            paginationEl = <Pagination {...pagination} />;
        }
        return (
            <div>
                {productList}
                {paginationEl}
            </div>
        );
    },
    updateCar: function (car) {
        this.setState({car: car});
    },
    update: function (state) {
        this.setState({
            products: state.products,
            pagination: state.pagination,
            cartData: state.cart_data
        });
    },
    setWaiting: function(waiting) {
        this.setState({waiting: waiting});
    }
});

export default PagedProducts;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/paged-products.js
 **/